<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-4">
        <div class="card">
          <div class="card-header pb-0">
            <h6>이벤트 생성</h6>
          </div>
          <div class="card-body">
            <form @submit.prevent="saveEvent">

              <!-- 이벤트갯수 -->
              <div class="mb-3">
                <label for="eventCount" class="form-label">이벤트 카운트</label>
                <input
                  type="text"
                  v-model="form.eventCount"
                  id="eventCount"
                  class="form-control"
                  placeholder="예: 1"
                  required
                />
              </div>

              <!-- 이벤트 타입 -->
              <div class="mb-3">
                <label for="eventType" class="form-label">이벤트 타입</label>
                <select v-model="$store.state.DesignTestDataStore.eventType" id="eventType" class="form-select" required>
                  <option value="null" disabled selected>선택하세요</option>
                  <option v-for="info in commonDropdownInfos.eventType" :key="info.value" :value="info.value">{{ info.text }}</option>
                </select>
              </div>

              <!-- 액션 -->
              <div class="mb-3">
                <label for="action" class="form-label">액션</label>
                <select v-model="formData.action" id="action" class="form-select" required>
                  <option v-for="action in commonDropdownInfos.actions" :key="action" :value="action.value">{{ action.text }}</option>
                </select>
              </div>

              <!-- 제품 GTIN 또는 EPC -->
              <div class="mb-3" v-if="$store.state.DesignTestDataStore.eventType !== 'AggregationEvent'">
                <label for="epc" class="form-label">EPC (전자 제품 코드)</label>
                <input
                  type="text"
                  v-model="form.epc"
                  id="epc"
                  class="form-control"
                  placeholder="예: urn:epc:id:sgtin:0614141.107346.2017"
                  required
                />
              </div>

              <!-- AggregationEvent일 때 -->
              <div v-if="$store.state.DesignTestDataStore.eventType === 'AggregationEvent'">
                <div class="mb-3">
                  <label for="parentID" class="form-label">부모 EPC</label>
                  <input
                    type="text"
                    v-model="form.parentID"
                    id="parentID"
                    class="form-control"
                    placeholder="예: urn:epc:id:sscc:0614141.1234567890"
                    required
                  />
                </div>
                <div class="mb-3">
                  <label for="childEPCs" class="form-label">자식 EPC 목록 (콤마로 구분)</label>
                  <input
                    type="text"
                    v-model="form.childEPCs"
                    id="childEPCs"
                    class="form-control"
                    placeholder="예: urn:epc:id:sgtin:0614141.107346.2017, urn:epc:id:sgtin:0614141.107346.2018"
                    required
                  />
                </div>
              </div>

              <!-- 이벤트 발생 시간 -->
              <div class="mb-3">
                <label for="eventTime" class="form-label">이벤트 발생 시간</label>
                <input
                  type="datetime-local"
                  v-model="formData.eventTimeSelector"
                  id="eventTime"
                  class="form-control"
                  required
                />
              </div>

              <!-- bizStep -->
              <div class="mb-3">
                <label for="bizStep" class="form-label">업무 단계 (Biz Step)</label>
                <select v-model="formData.businessStep" id="bizStep" class="form-select" required>
                  <option value="null" disabled selected>선택하세요</option>
                  <option v-for="step in commonDropdownInfos.businessSteps" :key="step" :value="step.value">{{ step.text }}</option>
                </select>
              </div>

              <!-- disposition -->
              <div class="mb-3">
                <label for="disposition" class="form-label">처리 상태 (Disposition)</label>
                <select v-model="formData.disposition" id="disposition" class="form-select">
                  <option value="null" disabled selected>선택하세요</option>
                  <option v-for="dp in commonDropdownInfos.dispositions" :key="dp" :value="dp.value">{{ dp.text }}</option>
                </select>
              </div>

              <!-- Read Point -->
              <div class="mb-3">
                <label for="readPoint" class="form-label">Read Point</label>
                <input
                  type="text"
                  v-model="formData.readPoint.manualURI"
                  id="readPoint"
                  class="form-control"
                  placeholder="예: urn:epc:id:sgln:088123456.00001.0"
                />
              </div>

              <!-- Biz Location -->
              <div class="mb-3">
                <label for="bizLocation" class="form-label">Biz Location</label>
                <input
                  type="text"
                  v-model="formData.bizLocation.manualURI"
                  id="bizLocation"
                  class="form-control"
                  placeholder="예: urn:epc:id:sgln:088123456.00001.0"
                />
              </div>

              <!-- 참여자 (참여자 ID / 역할) -->
              <div class="mb-3">
                <label for="participantId" class="form-label">참여자 ID (Participant ID)</label>
                <input
                  type="text"
                  v-model="form.participantId"
                  id="participantId"
                  class="form-control"
                  placeholder="예: user"
                />
              </div>

              <soft-button type="submit" color="success" variant="gradient">이벤트 작성</soft-button>
            </form>
          </div>
        </div>
      </div>

      <div class="col-4">
        <div class="card">
          <div class="card-header pb-0">
              <h6>이벤트 작성 데이터</h6>
          </div>
          <div class="card-body">
            <pre>{{ JSON.stringify(previewData, null, 2) }}</pre>
          </div>
        </div>
      </div>

      <div class="col-4">
        <div class="card mb-3">
          <div class="card-header pb-0">
              <h6>이벤트 전송 JSON</h6>
          </div>
          <div class="card-body">
            <pre v-html="dataResult"></pre>
            <soft-button v-if="dataResult" color="success" variant="gradient" @click="sendEventApi()">API전송</soft-button>
          </div>
        </div>
        <div class="card">
          <div class="card-header pb-0">
              <h6>이벤트 전송 XML</h6>
          </div>
          <div class="card-body">
            <pre style="white-space: pre-wrap; word-break: break-word;">{{ formattedXml }}</pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";
import axios from 'axios';

export default {
  name: "EPCISEventCreate",
  components: {
    SoftButton,
  },
  computed: {
    previewData() {
      const createDataInfo = {}
      createDataInfo.identifierSyntax =
        this.$store.state.IdentifiersStore.identifierSyntax
      createDataInfo.eventType =
        this.$store.state.DesignTestDataStore.eventType
      createDataInfo.eventCount =
        this.$store.state.DesignTestDataStore.eventCount
      createDataInfo.parentIdentifiersList =
        this.$store.state.IdentifiersStore.parentIdentifiersList
      createDataInfo.sensorElementList =
        this.$store.state.SensorElementsStore.sensorElementList
      createDataInfo.userExtensions =
        this.$store.state.ExtensionDataStore.userExtensions
      createDataInfo.sources =
        this.$store.state.SourceDestinationStore.sources
      createDataInfo.destinations =
        this.$store.state.SourceDestinationStore.destinations
      createDataInfo.formData = this.formData

      return createDataInfo
    },
    formattedXml() {
      return this.formatXml(this.dataResultXml);
    }
  },
  data() {
    return {
      commonDropdownInfos: {},
      form: {
        eventCount: "1",
        eventType: "",
        action: "",
        eventTime: "",
        epc: "",
        parentID: "",
        childEPCs: "",
        bizStep: "",
        disposition: "",
        readPoint: "",
        bizLocation: "",
        participantId: "",
      },
      formData: {
        vocabularySyntax: 'URN',
        ordinaryEvent: true,
        eventTimeSelector: 'SpecificTime',
        eventTime: {},
        RecordTimeOption: 'no',
        recordTimeType: 'SAME_AS_EVENT_TIME',
        readpointselector: 'manually',
        readPoint: {
          gcpLength: null,
          manualURI: "",
        },
        businesslocationselector: "manually",
        bizLocation: {
          gcpLength: null,
          manualURI: "",
        },
        businessStep: null,
        disposition: null,
        PersistentDispositionType: null,
        PersistentDisposition: null,
        persistentDispositionCount: 0,
        persistentDispositionList: [],
        businessTransactionCount: 0,
        businessTransactionList: [],
        errorCorrectiveCount: 0,
        errorCorrectiveIdsList: [],
        eventID: true,
        eventIdType: 'UUID',
        hashAlgorithm: 'sha-256',
        action: 'ADD',
      },
      dataResult: '',
      dataResultXml: '',
      eventTypes: [
        "ObjectEvent",
        "AggregationEvent",
        "TransactionEvent",
        "TransformationEvent",
        "AssociationEvent",
      ],
      actions: ["ADD", "OBSERVE", "DELETE"],
      bizSteps: [
        "commissioning",
        "shipping",
        "receiving",
        "storing",
        "inspecting",
        "packing",
        "unpacking",
      ],
      dispositions: ["active", "in_transit", "disposed", "stored"],
    };
  },
  mounted () {
    this.setDefaultTime();

    this.$store.dispatch('DesignTestDataStore/readStaticData');
    this.commonDropdownInfos = this.$store.state.DesignTestDataStore.commonDropdownInfos
    let now = new Date()
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset())
    now.setSeconds(now.getSeconds(), 0)
    now = now.toISOString().slice(0, -1)

    let yesterday = new Date()
    yesterday.setDate(new Date().getDate() - 1)
    yesterday.setMinutes(
      yesterday.getMinutes() - yesterday.getTimezoneOffset()
    )
    yesterday.setSeconds(yesterday.getSeconds(), 0)
    yesterday = yesterday.toISOString().slice(0, -1)

    this.formData.eventTime = {
      specificTime: now,
      fromTime: yesterday,
      toTime: now,
      timeZoneOffset: '+02:00'
    }

    // If user has passed query parameter along with the page URL then query for the provided url and obtain the data and load
    if (this.$route.query.url !== undefined && this.$route.query.url !== null) {
      this.$store.dispatch(
        'DesignTestDataStore/obtainURLData',
        this.$route.query.url
      )
      this.$store.commit('DesignTestDataStore/hideImportDesignModal')
    }
  },
  methods: {
    setDefaultTime(){
      const now = new Date();
      const offset = now.getTimezoneOffset();
      const localISOTime = new Date(now.getTime() - offset * 60000)
        .toISOString()
        .slice(0, 16); // 'YYYY-MM-DDTHH:mm'

      this.formData.eventTimeSelector = localISOTime;
    },
    async saveEvent() {
      this.$store.dispatch('TestDataJsonPreparator/jsonPreparation', {
        formData: this.formData
      })
      
      this.$store.commit(
        'TestDataGeneratorStore/populateTestDataInput',
        JSON.stringify(
          this.$store.state.TestDataJsonPreparator.testDataInputTemplate
        )
      )

      await this.$store.dispatch('TestDataGeneratorStore/testdataGenerator');
      this.dataResult = JSON.stringify(this.$store.state.TestDataGeneratorStore.testDataOutput, null, 2);

      this.$store.commit('modules/IdentifiersStore/populateInstanceIdentifiers',[])

      try {
        const headers = { 'Content-Type': 'application/json' };
        const xmlResponse = await axios.post(
          `/api/gen/generateTestDataXML`,
          JSON.parse(JSON.stringify(this.dataResult)),
          { headers }
        )
        this.dataResultXml = xmlResponse.data;
      } catch (error) {
        console.log(error);
      }
          
    },
    formatXml(xml) {
      if(!xml) return '';
      const PADDING = ' '.repeat(2); // 들여쓰기 2칸
      const reg = /(>)(<)(\/*)/g;
      let pad = 0;
      xml = xml.replace(reg, '$1\r\n$2$3');
      return xml
        .split('\r\n')
        .map((node) => {
          let indent = 0;
          if (node.match(/.+<\/\w[^>]*>$/)) {
            indent = 0;
          } else if (node.match(/^<\/\w/)) {
            if (pad !== 0) pad -= 1;
          } else if (node.match(/^<\w([^>]*[^/])?>.*$/)) {
            indent = 1;
          } else {
            indent = 0;
          }

          const padding = PADDING.repeat(pad);
          pad += indent;
          return padding + node;
        })
        .join('\r\n');
    },
    sendEventApi(){
      try {
        const jsonData = JSON.parse(this.dataResult); // 문자열 → JSON 객체로 파싱

        //jsonData.epcisBody.eventList[0].epcList = [this.form.epc];

        const eventType = this.$store.state.DesignTestDataStore.eventType;

        // 공통 이벤트 구조 (첫 번째 이벤트)
        const event = jsonData.epcisBody.eventList[0];

        const mfId = this.$store.getters['UserStore/getMfId'];
        if (mfId && mfId.trim() !== "") {
          event["cbv:extension"] = {
            companyPrefix: mfId
          };
        }

        // 조건 분기: AggregationEvent vs 기타
        if (eventType === 'AggregationEvent') {
          event.parentID = this.form.parentID;

          // 자식 EPC 문자열을 배열로 변환 (콤마 기준)
          const children = this.form.childEPCs
            .split(',')
            .map(e => e.trim())
            .filter(e => e !== '');

          event.childEPCs = children;

          // epcList 제거 (AggregationEvent에서는 사용하지 않음)
          delete event.epcList;
        } else {
          // 일반 이벤트
          event.epcList = [this.form.epc];

          // Aggregation 관련 필드 제거
          delete event.parentID;
          delete event.childEPCs;
        }

        fetch(`/api/epcisAPI/capture`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(jsonData),
        })
        .then(response => {
          if (response.ok) {
            return response.text().then(text => {
              return text ? JSON.parse(text) : {};
            });
          } else {
            throw new Error("응답 오류: " + response.status);
          }
        })
        .then(result => {
          this.toastSuccess("저장 되었습니다.");
          console.log('응답:', result);
        })
        .catch(error => {
          console.error('전송 실패:', error);
          alert('전송 중 오류가 발생했습니다.');
        });
      } catch (e) {
        alert('유효한 JSON 형식이 아닙니다.');
        console.error('JSON 파싱 에러:', e);
      }
    }
  },
};
</script>
